<template>
    <div>
        <!-- MENSAJES -->
        <mensajeSistema></mensajeSistema>

        <!-- BUTÓN CREAR Y TABLA -->
        <v-row>
            <v-col class="d-flex flex-row-reverse">
                <Button textButton="Crear Normativa Ministerial" color="addButton" normalButton iconBut="fas fa-plus"
                    @click="openModalCrearNormativas()"></Button>
            </v-col>

            <v-col cols="12">
                <v-data-table :headers="header" :items="normativas_ministeriales">
                    <!-- NIVELES Y GRADOS -->
                       <template v-slot:[`item.niveles_grados_ck1`]="{ item }">
                            <v-btn class="mx-2 btn_ver" fab x-small @click="openModalNivelesGrados(item)">
                            <v-icon>fa-graduation-cap</v-icon>
                            </v-btn>
                        </template>

                    <!-- SUBIR O VISUALIZAR DOCUMENTO -->
                    <template v-slot:[`item.upload_document`]="{}">
                        <v-btn class="mx-2 btn_editar" fab x-small>
                        <v-icon>fa-file-upload</v-icon>
                        </v-btn>
                    </template>

                    <!-- ESTADO -->
                    <template v-slot:[`item.estado`]="{ item }">
                        <div class="switch-container">
                        <v-switch color="success" v-model="item.estado" inset @change="updateNormativa(item)">
                        </v-switch>
                        <span class="switch-text" :style="item.estado ? 'width: 80%' : 'width: 100%'">
                            {{ item.estado ? 'ACTIVO' : 'INACTIVO' }}
                        </span>
                        </div>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <!-- FORMULARIO MODAL CREACIÓN DE NORMATIVA -->
        <v-form>
            <v-dialog v-model="modalCreacion" persistent scrollable max-width="800">
                <v-card>

                    <!-- TÍTULO -->
                    <v-card-title class="btn_otro">
                        <label> {{ "Crear normativas ministeriales" }} </label>
                        <v-spacer></v-spacer>
                        <v-btn fab dark x-small class="btn_style3" @click="modalCreacion = false">
                            <v-icon dark>fa-times</v-icon>
                        </v-btn>
                    </v-card-title>

                    <!-- NOMBRE Y SELECTS  -->
                    <v-card-text class="pt-3">
                        <v-layout wrap>

                            <v-col>
                                <v-text-field type="text" label="Nombre de la normativa ministerial"
                                    v-model="nombre_normativa" />
                            </v-col>

                            <v-col>
                                <v-select label="País" :items="paises" item-value="id" item-text="nombre_pais"
                                    v-model="paisSeleccionado" @change="getNivelesGrados()">

                                </v-select>
                            </v-col>

                        </v-layout>
                    </v-card-text>

                    <!-- TIMELINE NIVELES Y GRADOS SELECCIONADOS -->
                    <v-timeline class="pa-6">
                        <v-timeline-item v-for="(item,i) in niveles_grados" :key="i" size="small">
                            <div>
                                <h2>{{ item.desc_nivel }}</h2>
                            </div>
                            <div class="d-flex">
                                <div>
                                    <strong> Grados:</strong>
                                    <div class="text-caption" v-for="(grados, o) in item.grados" :key="o">
                                        {{ grados.desc_grado }}
                                    </div>

                                </div>
                            </div>
                        </v-timeline-item>

                    </v-timeline>

                    <!-- BOTÓN CREAR NORMATIVA -->
                    <v-col class="d-flex flex-row-reverse">
                        <Button textButton="Crear" iconBut="fas fa-plus" @click="crearNormativa()"></Button>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-form>

        <!-- MODAL VISUALIZAR NIVELES Y GRADOS -->
        <v-dialog v-model="modalNivelesGrados" persistent scrollable max-width="800">
            <v-card>
                <v-card-title class="btn_otro">
                    <label> {{ "Crear normativas ministeriales" }} </label>
                    <v-spacer></v-spacer>
                    <v-btn fab dark x-small class="btn_style3" @click="modalNivelesGrados = false">
                        <v-icon dark>fa-times</v-icon>
                    </v-btn>
                </v-card-title>

                <v-timeline class="pa-6">
                    <v-timeline-item v-for="(item, i) in niveles_grados" :key="i">
                        <div>
                            <h2>{{ item.desc_nivel }}</h2>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex">
                                <div>                                    
                                    <strong> Grados:</strong>
                                    <div class="text-caption" v-for="(grados, o) in item.grados" :key="o">
                                        {{ grados.desc_grado }}                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-timeline-item>
                </v-timeline>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
import axios from "../../../../helpers/axios"
import Button from '../../../../components/ComponentsEst/TableButtonComp.vue';
import { mapMutations } from "vuex";

export default {
    components: {
        Button,
    },
    props: ['normativas_ministeriales'],

    data: () => ({
        // Modales
        modalCreacion: false,
        modalNivelesGrados: false,

        // Header y data
        header: [
            {
                text: 'Nombre de la normativa',
                value: 'nombre_normativa',
                class: 'secondary black--text'
            },
            {
                text: 'Niveles y grados',
                value: 'niveles_grados_ck1',
                class: 'secondary black--text'
            },
            {
                text: 'Documentos',
                value: 'upload_document',
                class: 'secondary black--text'
            },
            {
                text: "Estado",
                value: "estado",
                class: "secondary black--text"
            },
        ],

        // Variables
        nombre_normativa: "",
        paises: [],
        niveles_grados: [],
        niveles: [],
        grados: [],

        // Variables seleccionadas
        paisSeleccionado: null,
        nivelSeleccionado: null,
        gradosSeleccionados: [],
    }),

    mounted() {
        this.getPaises();
        console.log(this.normativas_ministeriales)
    },

    methods: {

        /* ______________________
        |  PETICIONES AL BACK  */
        async getPaises() {
            try {
                const response = await axios.get('/mantenimiento/paises/paisesConfigurados/');

                this.paises = response.data;
            } catch (error) {
                console.log(error)
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al traer los paises.'
                });
            }

        },

        async getNivelesPais() {
            try {
                const response = await axios.get(`/manager/nivelCkOne/pais/${this.paisSeleccionado}`);

                this.niveles = response.data;
            } catch (error) {
                console.log(error.message)
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al traer los niveles de ese país.'
                });
            }
        },

        async getGrados() {
            try {
                const response = await axios.get(`/manager/gradoCkOne/grados/${this.nivelSeleccionado}`);

                this.grados = response.data;
            } catch (error) {
                console.log(error.message);
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al traer los grados.'
                });
            }
        },

        async getNivelesGrados() {
            try {
                const response = await axios.get(`/manager/gradoCkOne/nivelGrado/pais/${this.paisSeleccionado}`);

                let modified = []

                //Adapto el resultado para que sea iterable en el timeline
                if (response.data) {
                    response.data.forEach((item) => {
                        let obj = {};
                        let existeNivel = modified.some(obj => obj.id_nivel == item.id_nivel);

                        if (!existeNivel) {

                            obj = {
                                id_nivel: item.id_nivel,
                                desc_nivel: item.desc_nivel,
                                color: item.color,
                                grados: [{
                                    id_grado: item.id,
                                    desc_grado: item.desc_grado
                                }],
                            }

                            modified.push(obj);
                        } else {

                            let indice = modified.findIndex(n => n.id_nivel == item.id_nivel);

                            modified[indice].grados.push({
                                id_grado: item.id,
                                desc_grado: item.desc_grado
                            });
                        }
                    })
                }

                this.niveles_grados = modified;

            } catch (error) {
                console.log(error.message)
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al traer los niveles y grados.'
                });
            }
        },

        async crearNormativa() {
            try {
                //Condición para que solo el Mánager sea capaz de crear las condiciones
                let id_perfil = sessionStorage.getItem('id_perfil');
                let id_colegio = sessionStorage.getItem('id_colegio');

                if (id_perfil != 30) {
                    this.setEnviarMens({
                        tipo: 'W',
                        mensaje: 'No cumple con los permisos suficientes para crear normativas ministeriales.',
                        tiempo: 3000
                    })

                    return
                } else {
                    let data = {
                        niveles_grados: this.niveles_grados,
                        nombre_normativa: this.nombre_normativa,
                        id_perfil,
                        id_colegio,
                        id_pais: this.paisSeleccionado
                    };

                    const response = await axios.post('/cierreanio/cierreanioituacionestudiante/create-normativa/', data);

                    if (response.data.messageT == 'S') {
                        this.setEnviarMens({
                            tipo: response.data.messageT,
                            mensaje: response.data.message,
                            tiempo: 3000
                        });

                        this.modalCreacion = false;
                        //this.getNormativas();  //ACA LE DEBO DECIR AL PADRE QUE VUELVA A CARGAR LA DATA

                    }

                }
            } catch (error) {
                console.log(error)
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al intentar crear las normativas ministeriales.'
                })
            }

        },

        async updateNormativa(item) {
            try {
                const data = {
                    id: item.id,
                    estado: item.estado
                }
                const response = await axios.put('/cierreanio/cierreanioituacionestudiante/update-normativa', data);

                this.setEnviarMens({
                    tipo: response.data.messageT,
                    mensaje: response.data.message
                })

            } catch (error) {
                this.setEnviarMens({
                    tipo: 'W',
                    message: 'Hubo un error al actualizar el estado.'
                });
            }
        },

        /* ______________________
        |  FUNCIONES DE APOYO  */
        openModalCrearNormativas() {
            let normativaAbierta = this.normativas_ministeriales.some(item => item.estado == true);

            if (normativaAbierta == false) {
                this.modalCreacion = true;
            } else {
                this.setEnviarMens({
                    tipo: 'W',
                    mensaje: 'Para implementar una nueva normativa, la normativa actual debe estar desactivada.'
                });
            }
        },

        openModalNivelesGrados(item) {
            this.modalNivelesGrados = true;
            this.niveles_grados = item.niveles_grados_ck1;
        },

        //Mensajes de alertas
        ...mapMutations("mensajeSis", ["setEnviarMens"])
    }

}

</script>

<style>
.switch-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
}

.switch-text {
    position: absolute;
    pointer-events: none;
    font-weight: bold;
    font-size: 12px;
}

.switch-container .v-input--switch--inset .v-input--selection-controls__input,
.switch-container .v-input--switch--inset .v-input--switch__track {
    width: 92px;
}

.v-application--is-ltr .switch-container .v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple,
.v-application--is-ltr .switch-container .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
    transform: translate(65px) !important;
}
</style>